import { el, btn } from '@/ui/dom';

/**
 * catTabs.ts (M128c, owner: "have the buttons and headers for Paint Jobs,
 * Tires & Rims and Mods look more like the menu buttons on the home page") —
 * the shop's category tabs and the garage CUSTOMIZE overlay's category chips
 * are the SAME component now: a home-page menu card (`.mcard`: the skewed
 * accent icon zone, italic display title, uppercase sub) sized down to a tab.
 * The active tab wears the hero card's gold (`.mcard-primary`).
 */

export type CategoryKey = 'paintjobs' | 'tires' | 'mods';

/** The three category glyphs (the M113 icon-tile art, kept). */
export const CATEGORY_ICONS: Record<CategoryKey, string> = {
  paintjobs:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 4.5h12v4H4zM16 6h3v4.5h-7"/><path d="M12 10.5v3"/><rect x="10.5" y="13.5" width="3" height="6.5" rx="1"/></svg>',
  tires:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="8.4"/><circle cx="12" cy="12" r="3.1"/><path d="M12 3.6v5.3M12 15.1v5.3M3.6 12h5.3M15.1 12h5.3"/></svg>',
  mods:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.2 6.3a4.4 4.4 0 0 1 5.6-5L16.6 4.5l.6 2.3 2.3.6 3.2-3.2a4.4 4.4 0 0 1-5 5.6L8.8 18.7a2.1 2.1 0 0 1-3-3l8.4-9.4Z"/><path d="m5 13.5-2.7 2.6a2.5 2.5 0 0 0 0 3.6l2 2a2.5 2.5 0 0 0 3.6 0l2.6-2.7"/></svg>',
};

export interface CatTabSpec {
  key: CategoryKey;
  title: string;
  sub: string;
  on: boolean;
  onClick: () => void;
}

/** One category tab in the home-menu language. Returns the button. */
export function catTab(parent: HTMLElement, spec: CatTabSpec): HTMLButtonElement {
  const b = btn('', `mcard cat-tab cat-tab-${spec.key}${spec.on ? ' on mcard-primary' : ''}`, parent, spec.onClick);
  b.setAttribute('aria-pressed', String(spec.on));
  const ico = el('span', 'mcard-icon', b);
  ico.innerHTML = CATEGORY_ICONS[spec.key]; // static SVG constant
  const txt = el('span', 'mcard-text', b);
  el('span', 'mcard-title', txt).textContent = spec.title;
  el('span', 'mcard-sub', txt).textContent = spec.sub;
  return b;
}
